﻿import 'element-closest-polyfill';
import controller from '../../../../Resources/Scripts/_Shared/controller';
import { closeOverlay } from '../../_Shared/Scripts/MyAimoParkOverlay'

import React, { useState, Fragment } from 'react';
import ReactDOM from 'react-dom';

import { Divider } from '../../../../Resources/Scripts/_Shared/elements/Divider'
import { TwoColumnWrapper } from '../../../../Resources/Scripts/_Shared/elements/ColumnWrapper'
import { OneLineWrapper } from '../../../../Resources/Scripts/_Shared/elements/OneLineWrapper'
import { RadioButtonListWithLabel } from '../../../../Resources/Scripts/_Shared/elements/RadioButtonListWithLabel'
import { InputWithLabel } from '../../../../Resources/Scripts/_Shared/elements/InputWithLabel'
import { Error } from '../../../../Resources/Scripts/_Shared/elements/Error'
import { Dialog } from '../../../../Resources/Scripts/_Shared/elements/Dialog';

import { users } from './Endpoints'
import { validateFormObject } from '../../BookingFlowPage/Scripts/Validation'

function landlordAddNewForm(context) {
  const appContainer = context.querySelector('[data-app-container]');
  const appConfig = controller.getConfig(context);

  const App = () => {
    const type = appConfig.type;
    const lang = appConfig.localization;
    const [pending, setPending] = useState(false);
    const [error, setError] = useState(null);
    const [alreadyExistsError, setAlreadyExistsError] = useState(false);
    const [showSaveButtonCheck, setShowSaveButtonCheck] = useState(false);
    const [customerTypeSelectionOptions] = useState([
      { text: lang.person, id: 'B2C' },
      { text: lang.organization, id: 'B2B' },
    ]);

    const defaultTextboxSettings = { text: '', required: true };
    const [customerTypeSelection, setCustomerTypeSelection] = useState({ item: { id: 'B2C' }, elementType: 'radio' });
    const [firstName, setFirstName] = useState(defaultTextboxSettings)
    const [lastName, setLastName] = useState(defaultTextboxSettings)
    const [company, setCompany] = useState(defaultTextboxSettings)
    const [email, setEmail] = useState({ ...defaultTextboxSettings, elementType: 'email' })
    const currentLanguage = document.querySelector('html').getAttribute('lang');

    const resetForm = () => {
      setCustomerTypeSelection({ item: { id: 'B2C' }, elementType: 'radio' });
      setFirstName(defaultTextboxSettings);
      setLastName(defaultTextboxSettings);
      setCompany(defaultTextboxSettings);
      setEmail({ ...defaultTextboxSettings, elementType: 'email' });
    }

    const cancelClickHandler = () => {
      setError(null)
      resetForm();
      closeOverlay(context.closest('section[data-controller="myaimopark-overlay"]'), { persistMarkup: true });
    }

    const saveClickHandler = async () => {
      setPending(true);
      setError(null);

      const newUserForm = customerTypeSelection.item.id === 'B2C' ? {
        firstName: { value: firstName, setValue: setFirstName },
        lastName: { value: lastName, setValue: setLastName },
        email: { value: email, setValue: setEmail, error: false },
        customerTypeSelection: { value: customerTypeSelection, setValue: setCustomerTypeSelection },
      } : {
        company: { value: company, setValue: setCompany },
        email: { value: email, setValue: setEmail, error: false },
        customerTypeSelection: { value: customerTypeSelection, setValue: setCustomerTypeSelection },
      }

      const registeredAdminEmails = []
      const registeredAdminEmailsFromDom = document.querySelectorAll('.landlordadministratorspage__list .right');
      for (let i = 0; i < registeredAdminEmailsFromDom.length; i++) {
        registeredAdminEmails.push(registeredAdminEmailsFromDom[i].innerText)
      }

      if (registeredAdminEmails.includes(email.text)) {
        setAlreadyExistsError(true);
        setPending(false);
        return;
      }

      let [formValidationError, cleanFormData, flatCleanFormData] = validateFormObject(newUserForm, lang.errorMessages);

      if (formValidationError) {
        setPending(false);
        return;
      }

      const formData = {
        RecordType: flatCleanFormData.customerTypeSelection,
        isLandlordAdmin__c: (type === 'administrator'),
      }

      if (customerTypeSelection.item.id === 'B2C') {
        formData.personEmail = flatCleanFormData.email;
        formData.FirstName = flatCleanFormData.firstName;
        formData.LastName = flatCleanFormData.lastName;
      } else {
        formData.Company = flatCleanFormData.company;
        formData.Primary_Contact_Email_Address = flatCleanFormData.email;
      }

      //console.log('[FORM DATA]', formData)

      const createUserResponse = await users.createUser(formData, false, currentLanguage);

      if (createUserResponse.status === 200) {
        //console.log('[CREATE USER]', createUserResponse);

        setTimeout(() => {
          setPending(false);
          setTimeout(() => setShowSaveButtonCheck(true), 10);
          setTimeout(() => location.reload(), 1000);
        }, 2000);
        return;
      }
      else {
        setPending(false);
        //console.warn('Error body: ', createUserResponse.errorMessage);
        setError({
          error: true, errorText: createUserResponse.errorMessage
        });
        return;
      }
    }

    return (
      <Fragment>
        {type !== 'administrator' && <>
          <RadioButtonListWithLabel text={lang.customertype} options={customerTypeSelectionOptions} value={customerTypeSelection} setValue={setCustomerTypeSelection} disabled={pending} />
          <Divider />
        </>}

        <TwoColumnWrapper>
          {customerTypeSelection.item.id === 'B2C' && <InputWithLabel inputType="text" text={lang.firstname} value={firstName} setValue={setFirstName} />}
          {customerTypeSelection.item.id === 'B2C' && <InputWithLabel inputType="text" text={lang.lastname} value={lastName} setValue={setLastName} />}
          {customerTypeSelection.item.id === 'B2B' && <InputWithLabel inputType="text" text={lang.company} value={company} setValue={setCompany} />}
          <InputWithLabel inputType="email" text={lang.email} value={email} setValue={setEmail} />
        </TwoColumnWrapper>

        {error && error.errorText?.length > 0 && <Error text={error.errorText} />}

        <Divider />

        <OneLineWrapper>
          <button className="single-step__button single-step__button--cancel" disabled={pending} onClick={cancelClickHandler}>{lang.cancel}</button>
          <button className={showSaveButtonCheck ? 'single-step__button single-step__button--saveable single-step__button--complete' : 'single-step__button single-step__button--saveable'} data-pp-button={type === 'administrator' ? "create-administrator" : "create-customer" } disabled={pending || showSaveButtonCheck} aria-busy={pending} onClick={saveClickHandler}>{lang.save}</button>
        </OneLineWrapper>
        {alreadyExistsError &&
          <Dialog lang={lang.errorMessages} onDialogConfirm={() => { resetForm(); setAlreadyExistsError(false) }}>
            <p>{lang.errorMessages.alreadyadmin.replace('{0}', email.text)}</p>
          </Dialog>}
      </Fragment>
    );
  }

  function init() {
    ReactDOM.render(<App />, appContainer);
  }

  return {
    init
  };
}

controller.add('landlord-addnew-form', landlordAddNewForm);